import { Tag } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 0 0;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  min-height: 710px;
  max-height: 710px;
`;

export const TitleWrapper = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const DateWrapper = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  max-width: 70px;
`;

export const AccessCountWrapper = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black6};
`;

export const DateTextWrapper = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black6};
  text-transform: capitalize;
`;

export const AccessTag = styled(Tag)`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  background-color: ${({ theme }) => theme.colors.black3};

  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const AccessDateWrapper = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
`;
